import React from 'react';

import { Nullable } from '@clearverify/types';

import { EmployeeWhere, QueryMode, VerificationRequestWhere, VerifierStaffWhere } from 'src/api';
import { useCurrentUserPermissions } from 'src/hooks/user';
import { getEmployeeFilterManager } from 'src/utils/filters';
import { getUserFullNameFilter } from 'src/utils/user';

export const useVerificationRequestsSearchFilter = () => {
  const {
    hasPlatformRoles,
    isPlatformAdmin,
    isPlatformManager,
    hasEmployerRoles,
    isEmployerAdmin,
    isEmployerManager,
    isVerifierAdmin,
    hasPeoRoles,
    isPeoSuperAdmin,
    isPeoAdmin,
    isPeoManager,
  } = useCurrentUserPermissions();

  const prepareSearchFilter = React.useCallback<
    (searchValue: Nullable<string>) => VerificationRequestWhere
  >(
    searchValue => {
      let verifierStaffSearchFilter: VerifierStaffWhere = {};

      if (hasPlatformRoles || hasEmployerRoles || hasPeoRoles) {
        verifierStaffSearchFilter = {
          verifier: {
            displayName: {
              contains: searchValue,
              mode: QueryMode.Insensitive,
            },
          },
        };
      } else if (isVerifierAdmin) {
        verifierStaffSearchFilter = {
          user: getUserFullNameFilter(searchValue),
        };
      }

      let employeeSearchFilter: EmployeeWhere = {};

      if (isEmployerManager || isPlatformManager || isPeoManager) {
        employeeSearchFilter = getEmployeeFilterManager(searchValue);
      } else if (
        isPlatformAdmin ||
        isEmployerAdmin ||
        isVerifierAdmin ||
        isPeoAdmin ||
        isPeoSuperAdmin
      ) {
        employeeSearchFilter = {
          user: getUserFullNameFilter(searchValue),
        };
      }

      return searchValue && searchValue.length > 0
        ? {
            OR: [
              {
                employee: employeeSearchFilter,
              },
              {
                verifierStaff: verifierStaffSearchFilter,
              },
            ],
          }
        : {};
    },
    [
      hasPlatformRoles,
      hasEmployerRoles,
      hasPeoRoles,
      isVerifierAdmin,
      isEmployerManager,
      isPlatformManager,
      isPeoManager,
      isPlatformAdmin,
      isEmployerAdmin,
      isPeoAdmin,
      isPeoSuperAdmin,
    ],
  );

  return prepareSearchFilter;
};
